var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AbstractLocomotiveField',_vm._g(_vm._b({attrs:{"clearable":"","data-testid":"non-editable-locomotive-input"}},'AbstractLocomotiveField',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }